import React from 'react';
import { Crosshair, LocateFixed, Type } from 'lucide-react';
import { toast } from 'sonner';
import { puntoLabel } from '../../lib/googleMapsLinks';

export const requestCurrentLocation = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) { reject(new Error('Tu navegador no permite obtener la ubicación')); return; }
  navigator.geolocation.getCurrentPosition(
    (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
    (err) => reject(new Error(err.code === 1 ? 'Permiso de ubicación denegado' : 'No se pudo obtener la ubicación')),
    { enableHighAccuracy: true, timeout: 15000 },
  );
});

// Salida / regreso: dirección como texto (sin geocodificar), punto del mapa o ubicación actual.
export const PuntoInput = ({ label, value, onChange, onPickOnMap, picking, allowCurrent, tid }) => {
  const tipo = value?.tipo || 'texto';
  const useCurrent = async () => {
    try {
      const p = await requestCurrentLocation();
      onChange({ tipo: 'punto', lat: p.lat, lng: p.lng, texto: 'Mi ubicación al planificar' });
    } catch (e) { toast.error(e.message); }
  };
  return (
    <div data-testid={tid}>
      <p className="text-xs font-medium text-slate-600 mb-1">{label}</p>
      <div className="flex flex-wrap gap-1.5 mb-1.5">
        <button type="button" onClick={() => onChange({ tipo: 'texto', texto: value?.tipo === 'texto' ? value.texto : '' })} className={`btn-secondary text-xs px-2 py-1 flex items-center gap-1 ${tipo === 'texto' ? 'ring-2 ring-blue-400' : ''}`} data-testid={`${tid}-mode-texto`}>
          <Type className="w-3 h-3" /> Dirección
        </button>
        <button type="button" onClick={onPickOnMap} className={`btn-secondary text-xs px-2 py-1 flex items-center gap-1 ${picking ? 'ring-2 ring-blue-400' : ''}`} data-testid={`${tid}-mode-mapa`}>
          <Crosshair className="w-3 h-3" /> {picking ? 'Pulsa en el mapa…' : 'Punto en mapa'}
        </button>
        {allowCurrent && (
          <button type="button" onClick={useCurrent} className="btn-secondary text-xs px-2 py-1 flex items-center gap-1" data-testid={`${tid}-mode-actual`}>
            <LocateFixed className="w-3 h-3" /> Ubicación actual
          </button>
        )}
      </div>
      {tipo === 'texto' ? (
        <input value={value?.texto || ''} onChange={e => onChange({ tipo: 'texto', texto: e.target.value })} placeholder="Ej.: Calle Mayor 1, Madrid" className="input-base text-sm py-1.5" data-testid={`${tid}-texto`} />
      ) : (
        <p className="text-sm text-slate-700 bg-slate-50 rounded-md px-2 py-1.5 border border-slate-200" data-testid={`${tid}-resumen`}>{puntoLabel(value)}</p>
      )}
    </div>
  );
};

export default PuntoInput;
